import logo from "../../assets/images/nour-seen-logo.png";

const Footer = () => {
	return (
		<footer>
			<p>
				&copy; تم تطوير النظام بواسطة{" "}
				<a href="https://nsn.sa/" target="_blank" rel="noreferrer">
					<img src={logo} alt="Ejjadh" />
				</a>
				جميع الحقوق محفوظة
			</p>
		</footer>
	);
};

export default Footer;
